export const PATHS = {
    CITIES:
      "https://raw.githubusercontent.com/nhidh99/codergamo/master/004-location-selects/locations/cities.json",
    DISTRICTS:
      "https://raw.githubusercontent.com/nhidh99/codergamo/master/004-location-selects/locations/districts",
    WARDS:
      "https://raw.githubusercontent.com/nhidh99/codergamo/master/004-location-selects/locations/wards",
    LOCATION:
      "https://raw.githubusercontent.com/nhidh99/codergamo/master/004-location-selects/locations/location.json"
  };